import {keyframes} from "styled-components";
import {viewTransitionNew, createViewTransitionPair, viewTransitionOld} from "../utils/viewTransition.ts";

export const sampleTransitionNew = viewTransitionNew`
  animation-name: ${keyframes`
    from {
        transform: translateX(0);
        opacity: 1;
    }
    to {
        transform: translateX(-100%);
        opacity: 0;
    }
`};
  animation-duration: 500ms;
  animation-timing-function: ease-in-out;
`

export const sampleTransitionOld = viewTransitionOld`
  animation-name: ${keyframes`
    from {
        transform: translateX(0);
        opacity: 1;
    }
    to {
        transform: translateX(-100%);
        opacity: 0;
    }
`};
  animation-duration: 500ms;
  animation-timing-function: ease-in-out;
`


export const sampleTransitionPAir = createViewTransitionPair`
  animation-name: ${keyframes`
    from {
        transform: translateX(0);
        opacity: 1;
    }
    to {
        transform: translateX(-100%);
        opacity: 0;
    }
`};
  animation-duration: 500ms;
  animation-timing-function: ease-in-out;
``
  animation-name: ${keyframes`
    from {
        transform: translateX(0);
        opacity: 1;
    }
    to {
        transform: translateX(-100%);
        opacity: 0;
    }
`};
  animation-duration: 500ms;
  animation-timing-function: ease-in-out;
`